import Vue from 'vue'
import Vuex from 'vuex'
import {
  actions,
  mutations
} from './handle'

import {
  state,
  getters
} from './data'

Vue.use(Vuex)

// 导出模块
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js